import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterCBondsCadastroBondsTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "IDEmitenteFormal": null,
            "IDBloomberg": null,
            "TickerBloomberg": null,
            "CodigoCFI": null,
            "CodigoCFI144a": null,
            "Convertivel": null,
            "IDTipoCupom": null,
            "DataAtualizacao": dayjs().format(DATE_FORMAT),
            "PeriodoCupom": null,
            "IDMoeda": null,
            "Moeda": null,
            "Cusip144a": null,
            "CusipRegs": null,
            "DataFimColocacao": dayjs().format(DATE_FORMAT),
            "DataInicioCirculacao": dayjs().format(DATE_FORMAT),
            "DataInicioColocacao": dayjs().format(DATE_FORMAT),
            "DocumentoEng": null,
            "DocumentoRus": null,
            "DocumentoPol": null,
            "DocumentoIta": null,
            "DataResgateAntecipado": dayjs().format(DATE_FORMAT),
            "IDBaseCupomEmissao": null,
            "TituloBaseCupomEmissao": null,
            "IDEmitenteEmissao": null,
            "IDEmitente": null,
            "IDFilialEmitente": null,
            "NomeFilialEmitenteEng": null,
            "NomeFilialEmitenteRus": null,
            "TaxaFlutuante": null,
            "IDGarantidor": null,
            "MultiploIntegral": null,
            "ISIN": null,
            "ISIN144a": null,
            "ISIN3": null,
            "IDTipo": null,
            "Margem": null,
            "DataVencimento": dayjs().format(DATE_FORMAT),
            "NomeCurtoMicex": null,
            "ValorNominal": null,
            "NumeroEmissao": null,
            "NumeroEmissaoEng": null,
            "ValorNominalAtualizado": null,
            "IDTaxaReferencia": null,
            "NomeTaxaReferenciaEng": null,
            "NomeTaxaReferenciaRus": null,
            "DataRegistro": dayjs().format(DATE_FORMAT),
            "DataLiquidacao": dayjs().format(DATE_FORMAT),
            "NumeroRegistroEstadual": null,
            "IDStatus": null,
            "IDSubtipo": null,
            "DividaSubordinada": null,
            "IDVID": null,
            "CupomEng": null,
            "CupomRus": null,
            "NomeTipoEng": null,
            "NomeTipoRus": null,
            "NomeTipoPol": null,
            "NomeTipoIta": null,
            "PaisEmitente": null,
            "IDRegiaoPaisEmitente": null,
            "IDSubregiaoPaisEmitente": null,
            "NomeEmitenteEng": null,
            "NomeEmitenteRus": null,
            "DataOferta": dayjs().format(DATE_FORMAT),
            "HoraAtualizacao": null,
            "TitulosHipotecarios": null,
            "Reestruturacao": null,
            "DataReestruturacao": null,
            "Perpetuo": null,
            "MontanteCirculacaoRestante": null,
            "DividaGarantida": null,
            "NominalEurobonds": null,
            "NotaEstruturada": null,
            "InnEmitente": null,
            "NomeEmitenteFormalRus": null,
            "NomeTipoEmitenteRus": null,
            "VolumeAnunciado": null,
            "VolumeColocado": null,
            "VolumeEmCirculacao": null,
            "IndexadorEng": null,
            "IndexadorRus": null,
            "LivroOrdem": null
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            IDEmitenteFormal,
            IDBloomberg,
            TickerBloomberg,
            CodigoCFI,
            CodigoCFI144a,
            Convertivel,
            IDTipoCupom,
            DataAtualizacao,
            PeriodoCupom,
            IDMoeda,
            Moeda,
            Cusip144a,
            CusipRegs,
            DataFimColocacao,
            DataInicioCirculacao,
            DataInicioColocacao,
            DocumentoEng,
            DocumentoRus,
            DocumentoPol,
            DocumentoIta,
            DataResgateAntecipado,
            IDBaseCupomEmissao,
            TituloBaseCupomEmissao,
            IDEmitenteEmissao,
            IDEmitente,
            IDFilialEmitente,
            NomeFilialEmitenteEng,
            NomeFilialEmitenteRus,
            TaxaFlutuante,
            IDGarantidor,
            MultiploIntegral,
            ISIN,
            ISIN144a,
            ISIN3,
            IDTipo,
            Margem,
            DataVencimento,
            NomeCurtoMicex,
            ValorNominal,
            NumeroEmissao,
            NumeroEmissaoEng,
            ValorNominalAtualizado,
            IDTaxaReferencia,
            NomeTaxaReferenciaEng,
            NomeTaxaReferenciaRus,
            DataRegistro,
            DataLiquidacao,
            NumeroRegistroEstadual,
            IDStatus,
            IDSubtipo,
            DividaSubordinada,
            IDVID,
            CupomEng,
            CupomRus,
            NomeTipoEng,
            NomeTipoRus,
            NomeTipoPol,
            NomeTipoIta,
            PaisEmitente,
            IDRegiaoPaisEmitente,
            IDSubregiaoPaisEmitente,
            NomeEmitenteEng,
            NomeEmitenteRus,
            DataOferta,
            HoraAtualizacao,
            TitulosHipotecarios,
            Reestruturacao,
            DataReestruturacao,
            Perpetuo,
            MontanteCirculacaoRestante,
            DividaGarantida,
            NominalEurobonds,
            NotaEstruturada,
            InnEmitente,
            NomeEmitenteFormalRus,
            NomeTipoEmitenteRus,
            VolumeAnunciado,
            VolumeColocado,
            VolumeEmCirculacao,
            IndexadorEng,
            IndexadorRus,
            LivroOrdem
        } = newRow

        const body = {
            "IDEmitenteFormal": IDEmitenteFormal,
            "IDBloomberg": IDBloomberg,
            "TickerBloomberg": TickerBloomberg,
            "CodigoCFI": CodigoCFI,
            "CodigoCFI144a": CodigoCFI144a,
            "Convertivel": Convertivel,
            "IDTipoCupom": IDTipoCupom,
            "DataAtualizacao": DataAtualizacao,
            "PeriodoCupom": PeriodoCupom,
            "IDMoeda": IDMoeda,
            "Moeda": Moeda,
            "Cusip144a": Cusip144a,
            "CusipRegs": CusipRegs,
            "DataFimColocacao": DataFimColocacao,
            "DataInicioCirculacao": DataInicioCirculacao,
            "DataInicioColocacao": DataInicioColocacao,
            "DocumentoEng": DocumentoEng,
            "DocumentoRus": DocumentoRus,
            "DocumentoPol": DocumentoPol,
            "DocumentoIta": DocumentoIta,
            "DataResgateAntecipado": DataResgateAntecipado,
            "IDBaseCupomEmissao": IDBaseCupomEmissao,
            "TituloBaseCupomEmissao": TituloBaseCupomEmissao,
            "IDEmitenteEmissao": IDEmitenteEmissao,
            "IDEmitente": IDEmitente,
            "IDFilialEmitente": IDFilialEmitente,
            "NomeFilialEmitenteEng": NomeFilialEmitenteEng,
            "NomeFilialEmitenteRus": NomeFilialEmitenteRus,
            "TaxaFlutuante": TaxaFlutuante,
            "IDGarantidor": IDGarantidor,
            "MultiploIntegral": MultiploIntegral,
            "ISIN": ISIN,
            "ISIN144a": ISIN144a,
            "ISIN3": ISIN3,
            "IDTipo": IDTipo,
            "Margem": Margem,
            "DataVencimento": DataVencimento,
            "NomeCurtoMicex": NomeCurtoMicex,
            "ValorNominal": ValorNominal,
            "NumeroEmissao": NumeroEmissao,
            "NumeroEmissaoEng": NumeroEmissaoEng,
            "ValorNominalAtualizado": ValorNominalAtualizado,
            "IDTaxaReferencia": IDTaxaReferencia,
            "NomeTaxaReferenciaEng": NomeTaxaReferenciaEng,
            "NomeTaxaReferenciaRus": NomeTaxaReferenciaRus,
            "DataRegistro": DataRegistro,
            "DataLiquidacao": DataLiquidacao,
            "NumeroRegistroEstadual": NumeroRegistroEstadual,
            "IDStatus": IDStatus,
            "IDSubtipo": IDSubtipo,
            "DividaSubordinada": DividaSubordinada,
            "IDVID": IDVID,
            "CupomEng": CupomEng,
            "CupomRus": CupomRus,
            "NomeTipoEng": NomeTipoEng,
            "NomeTipoRus": NomeTipoRus,
            "NomeTipoPol": NomeTipoPol,
            "NomeTipoIta": NomeTipoIta,
            "PaisEmitente": PaisEmitente,
            "IDRegiaoPaisEmitente": IDRegiaoPaisEmitente,
            "IDSubregiaoPaisEmitente": IDSubregiaoPaisEmitente,
            "NomeEmitenteEng": NomeEmitenteEng,
            "NomeEmitenteRus": NomeEmitenteRus,
            "DataOferta": DataOferta,
            "HoraAtualizacao": HoraAtualizacao,
            "TitulosHipotecarios": TitulosHipotecarios,
            "Reestruturacao": Reestruturacao,
            "DataReestruturacao": DataReestruturacao,
            "Perpetuo": Perpetuo,
            "MontanteCirculacaoRestante": MontanteCirculacaoRestante,
            "DividaGarantida": DividaGarantida,
            "NominalEurobonds": NominalEurobonds,
            "NotaEstruturada": NotaEstruturada,
            "InnEmitente": InnEmitente,
            "NomeEmitenteFormalRus": NomeEmitenteFormalRus,
            "NomeTipoEmitenteRus": NomeTipoEmitenteRus,
            "VolumeAnunciado": VolumeAnunciado,
            "VolumeColocado": VolumeColocado,
            "VolumeEmCirculacao": VolumeEmCirculacao,
            "IndexadorEng": IndexadorEng,
            "IndexadorRus": IndexadorRus,
            "LivroOrdem": LivroOrdem
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDEmitenteFormal',
            headerName: 'IDEmitenteFormal',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDBloomberg',
            headerName: 'IDBloomberg',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'TickerBloomberg',
            headerName: 'TickerBloomberg',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'CodigoCFI',
            headerName: 'CodigoCFI',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'CodigoCFI144a',
            headerName: 'CodigoCFI144a',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'Convertivel',
            headerName: 'Convertivel',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTipoCupom',
            headerName: 'IDTipoCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataAtualizacao',
            headerName: 'DataAtualizacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'PeriodoCupom',
            headerName: 'PeriodoCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDMoeda',
            headerName: 'IDMoeda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'Moeda',
            headerName: 'Moeda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'Cusip144a',
            headerName: 'Cusip144a',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'CusipRegs',
            headerName: 'CusipRegs',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DataFimColocacao',
            headerName: 'DataFimColocacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataInicioCirculacao',
            headerName: 'DataInicioCirculacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataInicioColocacao',
            headerName: 'DataInicioColocacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DocumentoEng',
            headerName: 'DocumentoEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DocumentoRus',
            headerName: 'DocumentoRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DocumentoPol',
            headerName: 'DocumentoPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DocumentoIta',
            headerName: 'DocumentoIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DataResgateAntecipado',
            headerName: 'DataResgateAntecipado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'IDBaseCupomEmissao',
            headerName: 'IDBaseCupomEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TituloBaseCupomEmissao',
            headerName: 'TituloBaseCupomEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDEmitenteEmissao',
            headerName: 'IDEmitenteEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDEmitente',
            headerName: 'IDEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDFilialEmitente',
            headerName: 'IDFilialEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NomeFilialEmitenteEng',
            headerName: 'NomeFilialEmitenteEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NomeFilialEmitenteRus',
            headerName: 'NomeFilialEmitenteRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TaxaFlutuante',
            headerName: 'TaxaFlutuante',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDGarantidor',
            headerName: 'IDGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MultiploIntegral',
            headerName: 'MultiploIntegral',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ISIN144a',
            headerName: 'ISIN144a',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ISIN3',
            headerName: 'ISIN3',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDTipo',
            headerName: 'IDTipo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'Margem',
            headerName: 'Margem',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataVencimento',
            headerName: 'DataVencimento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'NomeCurtoMicex',
            headerName: 'NomeCurtoMicex',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ValorNominal',
            headerName: 'ValorNominal',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NumeroEmissao',
            headerName: 'NumeroEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NumeroEmissaoEng',
            headerName: 'NumeroEmissaoEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ValorNominalAtualizado',
            headerName: 'ValorNominalAtualizado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTaxaReferencia',
            headerName: 'IDTaxaReferencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NomeTaxaReferenciaEng',
            headerName: 'NomeTaxaReferenciaEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeTaxaReferenciaRus',
            headerName: 'NomeTaxaReferenciaRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DataRegistro',
            headerName: 'DataRegistro',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataLiquidacao',
            headerName: 'DataLiquidacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'NumeroRegistroEstadual',
            headerName: 'NumeroRegistroEstadual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDStatus',
            headerName: 'IDStatus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDSubtipo',
            headerName: 'IDSubtipo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DividaSubordinada',
            headerName: 'DividaSubordinada',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDVID',
            headerName: 'IDVID',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CupomEng',
            headerName: 'CupomEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'CupomRus',
            headerName: 'CupomRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeTipoEng',
            headerName: 'NomeTipoEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeTipoRus',
            headerName: 'NomeTipoRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeTipoPol',
            headerName: 'NomeTipoPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeTipoIta',
            headerName: 'NomeTipoIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'PaisEmitente',
            headerName: 'PaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDRegiaoPaisEmitente',
            headerName: 'IDRegiaoPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDSubregiaoPaisEmitente',
            headerName: 'IDSubregiaoPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NomeEmitenteEng',
            headerName: 'NomeEmitenteEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeEmitenteRus',
            headerName: 'NomeEmitenteRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DataOferta',
            headerName: 'DataOferta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'HoraAtualizacao',
            headerName: 'HoraAtualizacao',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime'
        },
        {
            field: 'TitulosHipotecarios',
            headerName: 'TitulosHipotecarios',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'Reestruturacao',
            headerName: 'Reestruturacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataReestruturacao',
            headerName: 'DataReestruturacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'Perpetuo',
            headerName: 'Perpetuo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MontanteCirculacaoRestante',
            headerName: 'MontanteCirculacaoRestante',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DividaGarantida',
            headerName: 'DividaGarantida',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NominalEurobonds',
            headerName: 'NominalEurobonds',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NotaEstruturada',
            headerName: 'NotaEstruturada',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'InnEmitente',
            headerName: 'InnEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeEmitenteFormalRus',
            headerName: 'NomeEmitenteFormalRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeTipoEmitenteRus',
            headerName: 'NomeTipoEmitenteRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'VolumeAnunciado',
            headerName: 'VolumeAnunciado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'VolumeColocado',
            headerName: 'VolumeColocado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'VolumeEmCirculacao',
            headerName: 'VolumeEmCirculacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IndexadorEng',
            headerName: 'IndexadorEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IndexadorRus',
            headerName: 'IndexadorRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'LivroOrdem',
            headerName: 'LivroOrdem',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterCBondsCadastroBondsTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterCBondsCadastroBondsTable